module.exports = __webpack_public_path__ + "img/lv14.a23e7ca0.png";